/** Where the address stands, as far as leaving the page goes. */
interface At {
  pathname: string;
}

/**
 * Whether a way to `next` leaves the page with something unsaved: only a new path does. A change
 * of the search alone - a tab, an area of the catalogue - keeps the page and its drafts.
 */
export const leavesUnsaved = (current: At, next: At, unsaved: boolean): boolean =>
  unsaved && current.pathname !== next.pathname;
